import FrontMarkerMap from "@/Components/Front/FrontMarkerMap";
import Container from "@/Components/Grid/Container";
import resolveLocaleRoute from "@/Helpers/resolveLocaleRoute";
import FrontLayout from "@/Layouts/System/FrontLayout";
import { Head, Link } from "@inertiajs/react";
import { useTranslation } from "react-i18next";
import FrontText from "@/Components/Front/FrontText";
import Column from "@/Components/Grid/Column";
import Row from "@/Components/Grid/Row";

const MapResults = ({ viewWarehouses, type, province, city, routeParams, queryParams, focusOn = {} }) => {
    const { t, i18n } = useTranslation();
    
    const newsletterImage = {
        src: '/storage/images/newsletter-consultant.png',
        alt: '',
        name: 'newsletter-consultant'
    };

    const currentBreadcrumbTitle = i18n.resolvedLanguage === 'pl'
        ? ((province == null && city == null) ? t('breadcrumbs.allWarehouses') : province != null ? province.name : city)
        : ((province == null && city == null) ? t('breadcrumbs.allWarehouses') : province != null ? province.name_en : city);

    let backRoute = null;
    
    if (type === 'single') {
        backRoute = resolveLocaleRoute(
            'front.warehouses',
            { ...routeParams, ...queryParams },
            i18n.resolvedLanguage
        );
    } else if (type === 'multi') {
        backRoute = resolveLocaleRoute(
            'front.warehouses.manyLocations',
            { ...routeParams, ...queryParams },
            i18n.resolvedLanguage
        );
    } else if (type === 'all') {
        backRoute = resolveLocaleRoute(
            'front.warehouses.all',
            null,
            i18n.resolvedLanguage
        )
    }

    return (
        <FrontLayout
            newsletterImage={newsletterImage}
            newsletterQuote='homepage.newsletter_quote'
            breadcrumbs={[
                { title: currentBreadcrumbTitle, current: true },
            ]}
        >
            <Head>
                <title>Warehousemarket.pl</title>
                <meta name="robots" content="noindex,nofollow"/>
            </Head>
            <Container className="relative">
                <Row>
                    <Column>
                        <div className="relative">
                            <Link href={backRoute}>
                                <div className="absolute right-0 z-30 mt-4 inline-flex bg-yellow text-light-blue border-light-blue hover:text-white hover:border-yellow hover:bg-light-blue items-center sm:px-4 px-2 min-w-[160px] py-3 min-h-14 border rounded-lg gap-[10px] transition ease-in-out duration-150 justify-center">
                                    <FrontText textSize={"14/17"} className="font-semibold">
                                    {t('search_form.return_to_search_form')}
                                    </FrontText>
                                </div>
                            </Link>
                        </div>
                    </Column>
                </Row>
            </Container>
            
            <section id="mapa" className="mb-20">
                <FrontMarkerMap initialZoom={8.5} allWarehouses={viewWarehouses} initialLat={parseFloat(focusOn.lat)} initialLng={parseFloat(focusOn.lng)}/>
            </section>
        </FrontLayout>
    );
};

export default MapResults;